import { render, staticRenderFns } from "./DaysDetails.vue?vue&type=template&id=15335fbe&scoped=true&"
import script from "./DaysDetails.vue?vue&type=script&lang=js&"
export * from "./DaysDetails.vue?vue&type=script&lang=js&"
import style0 from "./DaysDetails.vue?vue&type=style&index=0&id=15335fbe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15335fbe",
  null
  
)

export default component.exports